﻿import { ajaxPost, toFullQuery } from '../../utils/ajax';
import checkoutService from '../../api/checkout';
import { required, alpha, minLength, between, email, sameAs, maxLength, numeric, withParams } from 'vuelidate/lib/validators';

const updateShippingAddressUrl = '/teliadk/api/Address/UpdateAddress';

export default {
    name: 'order-address',
    data: () => ({
        showShippingAddressModal: false,
        address: {},
        newAddress: {},
        updateSuccessful: true,
        errors: [],
        errorMsg: '',
        failedInputs: {
            streetName: false,
            streetNumber: false,
            postCode: false,
            city: false,
        }
    }),
    props: ['addressInfo', 'blockview', 'blockid'],
    validations: {
        newAddress: {
            att: {
                maxLength: maxLength(63)
            },
            companyName: {
                maxLength: maxLength(63)
            },
            streetName: {
                required,
                maxLength: maxLength(80)
            },
            streetNumber: {
                required
            },
            postCode: {
                required,
                numeric,
                minLength: minLength(4),
                maxLength: maxLength(4)
            },
            city: {
                required,
                maxLength: maxLength(63)
            }
        }
    },
    mounted() {
        this.address = JSON.parse(JSON.stringify(this.addressInfo));
        this.newAddress = JSON.parse(JSON.stringify(this.addressInfo));

        document.addEventListener("keydown", (e) => {
            if (e.keyCode === 27) {
                this.showShippingAddressModal = false;
            }
        });

        document.addEventListener('click', (e) => {
            e = e || window.event;
            var target = e.target || e.srcElement;
            if (target.classList && target.classList.length > 0 && target.classList[0] === 'ts-modal') {
                this.showShippingAddressModal = false;
            }
        }, false);

    },
    methods: {
        hasBackendErrors(name) {
            let i = this.failedInputs.indexOf(name);
            if (i < 0) {
                //this.failedInputs.splice(i, 1);
                this.failedInputs = [];
            }
            return i < 0;
        },
        toggleModal() {
            this.showShippingAddressModal = !this.showShippingAddressModal;
        },
        updateShippingAddress() {
            this.failedInputs = [];
            const parameters = {
                AddressId: this.newAddress.addressId,
                Att: this.newAddress.att,
                CompanyName: this.newAddress.companyName,
                StreetName: this.newAddress.streetName,
                StreetNumber: this.newAddress.streetNumber,
                FloorNumber: this.newAddress.floorNumber,
                FloorSide: this.newAddress.floorSide,
                PostCode: this.newAddress.postCode,
                City: this.newAddress.city
            };
            
            ajaxPost(toFullQuery(updateShippingAddressUrl , {currentBlockId: this.blockid }), parameters)
                .then((res) => {
                    if (res) {
                        let json = JSON.parse(res);
                        if (json.length) {
                            this.updateSuccessful = false;
                            this.errors = json;
                            //for (let i = 0; i < json.length; i++) {
                            //    for (let j = 0; j < json[i].memberNames.length; j++) {
                                    
                            //    }
                            //}
                        }
                    } else {
                        this.address = JSON.parse(JSON.stringify(this.newAddress));
                        this.updateSuccessful = true;
                        this.toggleModal();
                    }
                })
                .catch((e) => {
                    this.updateSuccessful = false;
                    this.errorMsg = e;
                })
        }
    }
}
